import React, { useState } from 'react';

import moment from 'moment';

import { Report } from '~/components';
import {
  DateTime,
  Autocomplete,
  MultiAutocomplete,
  Input,
  RadioGroup,
  Select,
  Hidden,
} from '~/components/Form';
import { t } from '~/helpers';

function Relrecebimentonf20() {
  const [open, setOpen] = useState(true);
  const [valuePosto, setValuePosto] = React.useState(0);
  const [exibeMedicao, setExibeMedicao] = React.useState('1');
  const [isMedicaoFiltro, setIsMedicaoFiltro] = useState(true);
  const [selectedOption, setSelectedOption] = useState('LI');

  const [yesOrNo, setYesOrNo] = useState(0);

  const start = moment()
    .subtract({ day: 7 })
    .set({ hour: 0, minute: 0, second: 0 });
  const end = moment().set({ hour: 23, minute: 59, second: 59 });

  async function handleYesOrNo(value) {
    // await reference.current.setFieldValue('controla20grausposto', value);
    await setYesOrNo(value);
  }

  // const cellsUser = useMemo(
  //   () => [
  //     {
  //       id: 'codigousuario',
  //       label: t('s.cadastro.usuario.codigousuario'),
  //       filter: { type: 'text' },
  //     },
  //     {
  //       id: 'nomeusuario',
  //       label: t('s.cadastro.usuario.nomeusuario'),
  //       filter: { type: 'text' },
  //     },
  //   ],
  //   []
  // );

  const orderoptions = [
    { value: 'LI', label: t('s.relatorio.abastecimento.opcaolistagem') },
    { value: 'PC', label: t('s.relatorio.abastecimento.opcaopostocomboio') },
    { value: 'DT', label: t('s.relatorio.abastecimento.opcaodata') },
    { value: 'PD', label: t('s.relatorio.abastecimento.opcaoproduto') },
    { value: 'TP', label: t('s.relatorio.descarga.transportadora') },
    { value: 'PL', label: t('s.operacao.recebimento.placactdescarga') },
    { value: 'MT', label: t('s.relatorio.descarga.motorista') },
    { value: 'US', label: t('s.relatorio.descarga.usuario') },
  ];

  function handleSerializeForm(params) {
    // const idPosto = params.idposto === null ? '' : params.idposto;

    const idPosto =
      valuePosto === 0 ? '' : valuePosto?.map((posto) => posto.idposto);
    const idProduto = params.idproduto === null ? '' : params.idproduto;

    const objectSend = {
      ...params,
      idposto: idPosto, // params.idposto || '',
      idproduto: params.idproduto || '',
      tipoordenacaoreport: selectedOption,
    };

    console.log('handleSerializeForm', objectSend);

    return objectSend;
  }

  function alteraTipo(e) {
    // console.log(e);
    setSelectedOption(e);
  }

  function alteraExibeMedicao(e) {
    if (e) {
      handleYesOrNo(e);
    }

    setExibeMedicao(e);
    const isMedicaoSelected = e === '0';
    setIsMedicaoFiltro(isMedicaoSelected);
    if (!isMedicaoSelected) {
      setSelectedOption('LI');
    }
  }

  return (
    <Report
      open={open}
      onClose={() => setOpen(false)}
      title={t('s.relatorio.recebimentonf20')}
      relatorio="recebimento20"
      serialize={(param) => handleSerializeForm(param)}
      initials={{
        datahorainicial: start.format('DD/MM/YYYY HH:mm:ss'),
        datahorafinal: end.format('DD/MM/YYYY HH:mm:ss'),
        tipoordenacaoreport: 'LI',
      }}
    >
      <DateTime
        label={t('s.geral.opcoes.datahorainicial')}
        name="datahorainicial"
        serialize={(value) =>
          value.set({ seconds: 0 }).format('DD/MM/YYYY HH:mm:ss')
        }
        time
      />

      <DateTime
        label={t('s.geral.opcoes.datahorafinal')}
        name="datahorafinal"
        serialize={(value) =>
          value.set({ seconds: 0 }).format('DD/MM/YYYY HH:mm:ss')
        }
        time
      />

      <MultiAutocomplete
        multiple
        name="idposto"
        label="codigonomeposto"
        url="postoscomboios"
        unique="idposto"
        title={t('s.geral.postocomboio')}
        hiddens={[{ name: 'codigonomeposto' }]}
        getValue={(value) => {
          if (value[0]?.idposto !== null) {
            setValuePosto(value);
          }
        }}
      />

      {/* <Autocomplete
        name="unidadecomboio"
        label="codigonomeposto"
        url="postoscomboios"
        unique="idposto"
        title={t('s.geral.postocomboio')}
        defaultValue=""
        hiddens={[{ name: 'nomeposto' }, { name: 'idposto' }]}
      /> */}

      <Autocomplete
        name="idproduto"
        label="nomeproduto"
        url="produtos"
        unique="idproduto"
        title={t('s.menu.configuracao.produto')}
        defaultValue=""
        hiddens={[{ name: 'nomeproduto' }]}
      />

      <Input name="placactdescarga" label={t('s.menu.cadastro.placact')} />

      <Input name="numeronfdescarga" label={t('s.menu.cadastro.numeronf')} />

      {yesOrNo === '0' ? (
        <>
          <Select
            name="tipoordenacaoreport"
            variant="outlined"
            size="small"
            label={t('s.relatorio.abastecimento.tipoordenacao')}
            options={orderoptions}
            disabled={!isMedicaoFiltro}
            getValue={(e) => alteraTipo(e)}
          />
          {/* <pre>{JSON.stringify(yesOrNo)}</pre> */}
        </>
      ) : (
        <Hidden name="tipoordenacaoreport" value="LI" />
      )}

      <RadioGroup
        name="isMedicao"
        label={t('s.relatorio.geral.isMedicao')}
        options={[
          { label: t('s.geral.opcoes.sim'), value: '1' },
          { label: t('s.geral.opcoes.nao'), value: '0' },
        ]}
        value={exibeMedicao}
        getValue={(e) => alteraExibeMedicao(e)}
        defaultValue="1"
        serialize={(value) => value}
        row
      />

      {/* <PesquisaTabela
        name="codigousuario"
        label={t('s.relatorio.abastecimentocontingencia.frentista')}
        primary="codigousuario"
        secondary="nomeusuario"
        url="usuarios"
        header={cellsUser}
      /> */}

      {/* <Input
        name="distribuidora"
        label={t('s.relatorio.geral.distribuidora')}
      />

      <Input
        name="transportadora"
        label={t('s.relatorio.geral.transportadora')}
      />

      <Checkbox
        name="exibetanques"
        label={t('s.relatorio.recebimentonf.exibetanques')}
      /> */}

      <RadioGroup
        name="formato"
        label={t('s.relatorio.geral.formato')}
        options={[
          { label: 'PDF', value: 'pdf' },
          { label: 'Excel', value: 'excel' },
        ]}
        defaultValue="pdf"
        serialize={(value) => value}
        row
      />
    </Report>
  );
}

export default Relrecebimentonf20;
